var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({ marginTop: (_vm.getDimensions() === '56px' || ['deployVirtualMachine'].includes(this.$route.path.split('/')[2])) ? '' : '-5px' }),attrs:{"src":_vm.getImg(),"height":_vm.getDimensions(),"width":_vm.getDimensions()}})}
var staticRenderFns = []

export { render, staticRenderFns }